<template>
<div class="content repports">

<h3>Isteklo</h3>
<ul>
  <li v-for="item in inPast">
    <RouterLink :to="{name: 'page', params: {path: [item.type, item.uuid] }}"><date>{{ itemDate(item) }}</date> {{ item.title }}</RouterLink>
  </li>
</ul>
<h3>Danas i u sledećih 7 dana</h3>
<ul>
  <li v-for="item in inNext7Days">
    <RouterLink :to="{name: 'page', params: {path: [item.type, item.uuid] }}"><date>{{ itemDate(item) }}</date> {{ item.title }}</RouterLink>
  </li>
</ul>
<h3>U sledećih 30 dana</h3>
<ul>
  <li v-for="item in inNext30Days">
    <RouterLink :to="{name: 'page', params: {path: [item.type, item.uuid] }}"><date>{{ itemDate(item) }}</date> {{ item.title }}</RouterLink>
  </li>
</ul>
<h3>U sledećih 60 dana</h3>
<ul>
  <li v-for="item in inNext60Days">
    <RouterLink :to="{name: 'page', params: {path: [item.type, item.uuid] }}"><date>{{ itemDate(item) }}</date> {{ item.title }}</RouterLink>
  </li>
</ul>



</div>
</template>

<script>
import api from '@/Util/api';
import { Interval, DateTime } from 'luxon';


export default {
  props: [
    "params", "index", "active", "mode"
  ],
  data: ()=>({
    events: [],
  }),
  computed: {
    currentClient() {
      return this.stores.auth.currentClient;
    },
    inPast() {
      return this.events.filter(item=>this.itemDays(item)<0);
    },
    inNext7Days() {
      return this.events.filter(item=>this.itemDays(item)>=0 && this.itemDays(item)<=7);
    },
    inNext30Days() {
      return this.events.filter(item=>this.itemDays(item)>7 && this.itemDays(item)<=30);
    },
    inNext60Days() {
      return this.events.filter(item=>this.itemDays(item)>30 && this.itemDays(item)<=60);
    },
  },
  methods: {
    async loadEvents() {
      this.events=await api.list("ReportNextEvents");
      console.log(this.events);
    },
    itemDate(item) {
      return item.date.substring(0, 10); // TODO
    },
    itemDays(item) {
      if (!item.date)
        return null;
      var date=DateTime.fromISO(item.date.substring(0, 10));
      var diff=Interval.fromDateTimes(DateTime.now().set({hour:0, minute: 0, second: 0}), date);
      return diff.length("days");
    },
  },
  created() {
    var title="Naredni događaji";
    this.stores.page.pushPage(title, this.params.path, this.index);
    this.loadEvents();
  },
  unmounted() {
    this.stores.page.popPage();
  },
}
</script>
